import { CardHeaderSection } from "src/assets/styles/custom";

export default function ContentHeader({ children }: {children:JSX.Element}) {
  return <CardHeaderSection id="contentHeader">{children}</CardHeaderSection>
}
